import {
  connect
} from 'react-redux'
import { getCampaignById, getCampaignGroupAggregated, getCampaignChannelAggregated, setReportDateRange} from '../../actions/Campaign'
import {selectClient} from "../../actions/App";

import CampaignReport from '../../components/Campaigns/Report'

const mapStateToProps = (state) => {
	const { campaignAggregatedReport, campaignChannelAggregatedReport, campaignDetail, reportDateRange } = state.campaigns;
	const { clients } = state.app;
	return {
		campaignDetail,
		campaignAggregatedReport,
		campaignChannelAggregatedReport,
		reportDateRange : reportDateRange ? reportDateRange : "life-of-campaign",
		client_id: state.app.client_info && state.app.client_info.id,
    client_tz: state.app.client_info && state.app.client_info.timezone,
		client_info: state.app.client_info,
		clients
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getCampaignById(id) {
      dispatch(getCampaignById(id, false));
		},
		
		getCampaignGroupAggregated(id, dateRange) {
			dispatch(getCampaignGroupAggregated(id, dateRange));
		},

		getCampaignChannelAggregated(id, dateRange) {
			dispatch(getCampaignChannelAggregated(id, dateRange))
		},

		setReportDateRange(range) {
			dispatch(setReportDateRange(range.value))
		},

		selectClient(cid) {
			dispatch(selectClient(cid))
		}
	}
}

const CampaignReportContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(CampaignReport)

export default CampaignReportContainer


// WEBPACK FOOTER //
// ./src/containers/Campaigns/CampaignReport.js